// src/config.js

// Determine if we are running locally or in production
const isDevelopment = window.location.hostname === 'localhost';

const config = {
  // Backend API URL
  // Development: http://localhost:5000
  // Production: Replace with your deployed GCP/Cloud Run URL
  API_BASE_URL: isDevelopment 
    ? 'http://localhost:8080' 
    : 'https://janbharatai-backend-654378618110.asia-south1.run.app', // Your live URL

  // Firebase Configuration (already provided in your code)
  firebaseConfig: {
    apiKey: "AIzaSyCU22X_sbI0sTKg5HQ2so-jJ_-GYj-p6mc",
    authDomain: "chat.janbharatai.com",
    projectId: "janbharatai-firebase",
    storageBucket: "janbharatai-firebase.firebasestorage.app",
    messagingSenderId: "34661159102",
    appId: "1:34661159102:web:b451ab184d196d3f2cceef"
  }
};

export default config;